import $ from "jquery";

$(".share-button").click(function () {
	$(".sharebar").toggleClass("open");
});